import { Box } from '@mui/material';

export function SystemGraphic() {
  return (
    <Box
      component="svg"
      viewBox="0 0 500 500"
      sx={{
        width: '100%',
        height: 'auto',
        display: 'block',
      }}
    >
      {/* Background Grid Pattern */}
      <defs>
        <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(30, 185, 128, 0.1)" strokeWidth="1"/>
        </pattern>
        <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1EB980', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#22c997', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="cyanGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#55FFE1', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#1EB980', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      <rect width="500" height="500" fill="url(#grid)" />
      
      {/* Central Hub */}
      <circle cx="250" cy="250" r="70" fill="url(#greenGradient)" opacity="0.2" />
      <circle cx="250" cy="250" r="50" fill="none" stroke="url(#greenGradient)" strokeWidth="3" />
      <circle cx="250" cy="250" r="35" fill="url(#greenGradient)" />
      
      {/* Orbital Nodes - Top */}
      <circle cx="250" cy="100" r="30" fill="none" stroke="url(#cyanGradient)" strokeWidth="3" />
      <circle cx="250" cy="100" r="22" fill="url(#cyanGradient)" opacity="0.3" />
      <line x1="250" y1="215" x2="250" y2="130" stroke="url(#greenGradient)" strokeWidth="2" strokeDasharray="5,5" opacity="0.6" />
      
      {/* Orbital Nodes - Right */}
      <circle cx="400" cy="250" r="30" fill="none" stroke="url(#cyanGradient)" strokeWidth="3" />
      <circle cx="400" cy="250" r="22" fill="url(#cyanGradient)" opacity="0.3" />
      <line x1="285" y1="250" x2="370" y2="250" stroke="url(#greenGradient)" strokeWidth="2" strokeDasharray="5,5" opacity="0.6" />
      
      {/* Orbital Nodes - Bottom */}
      <circle cx="250" cy="400" r="30" fill="none" stroke="url(#cyanGradient)" strokeWidth="3" />
      <circle cx="250" cy="400" r="22" fill="url(#cyanGradient)" opacity="0.3" />
      <line x1="250" y1="285" x2="250" y2="370" stroke="url(#greenGradient)" strokeWidth="2" strokeDasharray="5,5" opacity="0.6" />
      
      {/* Orbital Nodes - Left */}
      <circle cx="100" cy="250" r="30" fill="none" stroke="url(#cyanGradient)" strokeWidth="3" />
      <circle cx="100" cy="250" r="22" fill="url(#cyanGradient)" opacity="0.3" />
      <line x1="215" y1="250" x2="130" y2="250" stroke="url(#greenGradient)" strokeWidth="2" strokeDasharray="5,5" opacity="0.6" />
      
      {/* Diagonal Nodes - Top Right */}
      <circle cx="360" cy="140" r="24" fill="rgba(30, 185, 128, 0.2)" stroke="#1EB980" strokeWidth="2" />
      <line x1="285" y1="215" x2="342" y2="158" stroke="#1EB980" strokeWidth="1.5" strokeDasharray="3,3" opacity="0.4" />
      
      {/* Diagonal Nodes - Top Left */}
      <circle cx="140" cy="140" r="24" fill="rgba(30, 185, 128, 0.2)" stroke="#1EB980" strokeWidth="2" />
      <line x1="215" y1="215" x2="158" y2="158" stroke="#1EB980" strokeWidth="1.5" strokeDasharray="3,3" opacity="0.4" />
      
      {/* Diagonal Nodes - Bottom Right */}
      <circle cx="360" cy="360" r="24" fill="rgba(30, 185, 128, 0.2)" stroke="#1EB980" strokeWidth="2" />
      <line x1="285" y1="285" x2="342" y2="342" stroke="#1EB980" strokeWidth="1.5" strokeDasharray="3,3" opacity="0.4" />
      
      {/* Diagonal Nodes - Bottom Left */}
      <circle cx="140" cy="360" r="24" fill="rgba(30, 185, 128, 0.2)" stroke="#1EB980" strokeWidth="2" />
      <line x1="215" y1="285" x2="158" y2="342" stroke="#1EB980" strokeWidth="1.5" strokeDasharray="3,3" opacity="0.4" />
      
      {/* Animated Pulse Circles */}
      <circle cx="250" cy="250" r="70" fill="none" stroke="#1EB980" strokeWidth="2" opacity="0.3">
        <animate attributeName="r" from="70" to="95" dur="2s" repeatCount="indefinite" />
        <animate attributeName="opacity" from="0.3" to="0" dur="2s" repeatCount="indefinite" />
      </circle>
      
      {/* Flow Indicators */}
      <circle cx="250" cy="180" r="5" fill="#55FFE1">
        <animate attributeName="cy" from="180" to="250" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="opacity" from="1" to="0" dur="1.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="320" cy="250" r="5" fill="#55FFE1">
        <animate attributeName="cx" from="320" to="250" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="opacity" from="1" to="0" dur="1.5s" repeatCount="indefinite" />
      </circle>
      
      {/* Labels */}
      <text x="250" y="258" textAnchor="middle" fill="white" fontSize="18" fontWeight="bold">SYSTEM</text>
      <text x="250" y="105" textAnchor="middle" dominantBaseline="middle" fill="#55FFE1" fontSize="13" fontWeight="600">PLAN</text>
      <text x="400" y="255" textAnchor="middle" dominantBaseline="middle" fill="#55FFE1" fontSize="13" fontWeight="600">BUILD</text>
      <text x="250" y="405" textAnchor="middle" dominantBaseline="middle" fill="#55FFE1" fontSize="13" fontWeight="600">DEPLOY</text>
      <text x="100" y="255" textAnchor="middle" dominantBaseline="middle" fill="#55FFE1" fontSize="13" fontWeight="600">TEST</text>
    </Box>
  );
}